import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseforgetPassword, useOtpVerify } from "../../actions/authActions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState();
  const { TextWeight } = textWeight();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      otpCode: "",
    },
  });

  const OtpVerification = useOtpVerify(setLoadingToapi, navigate);
  const reSendOtp = UseforgetPassword(setLoadingToapi, navigate, false);
  const emailOTPData = useSelector(
    (state) => state.app.emailOTPData.emailOTPData
  );
  const resendOtpHandler = () => {
    reSendOtp.mutate({
      email: emailOTPData,
    });
  };

  const onSubmit = (data) => {
    setLoadingToapi(true);
    OtpVerification.mutate({
      email: emailOTPData,
      otp: data.otpCode,
    });
  };
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    resendOtpHandler,
    onSubmit,
    loadingToapi,
    TextWeight,
  };
};
